import { gql } from '@apollo/client'
import { ArrowRightIcon, BodyText, Button, Snippet } from '@farol-ds/react'
import { JurisprudenceMetadata } from '@jusbrasil-web/shared-apollo-client/types'
import { useGA4Dispatcher } from '@jusbrasil-web/shared-ga4'
import { GA4ClickEvent } from '@jusbrasil-web/shared-ga4-events'

import styles from './cluster-doc-snippet.module.scss'

export interface ClusterDocSnippetProps {
  document: JurisprudenceMetadata
  isLazyLoadedSnippet?: boolean
}

export function ClusterDocSnippet(props: ClusterDocSnippetProps) {
  const { document, isLazyLoadedSnippet = false } = props

  const { addons, court, date, url } = document

  const { sendGA4Event } = useGA4Dispatcher()

  const onLinkClick = () => {
    sendGA4Event(
      new GA4ClickEvent({
        componentName: 'cluster_theses_jurisprudence',
        componentClass: 'result_snippet',
        selectedOption: isLazyLoadedSnippet ? 'show_more' : 'static_reference',
        resourceId: `JURISPRUDENCIA:${document.docId}`,
      })
    )
  }

  return (
    <Snippet>
      <Snippet.Container>
        <Snippet.Header>
          <Snippet.Title asChild>
            <h3>
              Caso julgado pelo {court.replace('_', '-')} em {new Date(date ?? '').getFullYear()}
            </h3>
          </Snippet.Title>
        </Snippet.Header>
        <Snippet.Body>
          <Snippet.Content>
            <BodyText className={styles.snippetContent}>
              {addons?.plainFacts ??
                'Ainda não há um resumo dos fatos para este caso, mas ele é relevante porque compartilha a mesma linha argumentativa que fundamenta a tese.'}
            </BodyText>
          </Snippet.Content>
        </Snippet.Body>
        <Snippet.Footnote>
          <Button
            data-testid="cluster-doc-snippet-link"
            onClick={onLinkClick}
            rightIcon={<ArrowRightIcon />}
            kind="plain"
            className={styles.button}
            asChild
          >
            <a href={url} target="_blank" rel="noreferrer">
              Ver ementa e mais detalhes
            </a>
          </Button>
        </Snippet.Footnote>
      </Snippet.Container>
    </Snippet>
  )
}

ClusterDocSnippet.fragments = {
  haystackItem: gql`
    fragment ClusterDocSnippet_haystackItem on HaystackItem {
      data {
        ... on JurisprudenceMetadata {
          docId
          court
          date
          addons {
            plainFacts
            legalThesisClusterLabels {
              clusterId
              clusterLabel
            }
          }
          url
        }
      }
    }
  `,
}
